import dayjs from 'dayjs';
import _ from 'lodash';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import env from '../../env';
import { AppClientId } from '../Shared/constants';

dayjs.extend(customParseFormat);
